import type { LucideIcon } from 'lucide-react';
import { cx } from '../../components/ui';

/** Big segmented tabs (icon + label), full width on phones. */
export function SegmentedControl<V extends string>({
  options,
  value,
  onChange,
  label,
}: {
  options: { value: V; label: string; icon?: LucideIcon }[];
  value: V;
  onChange: (v: V) => void;
  label: string;
}) {
  return (
    <div role="tablist" aria-label={label} className="flex w-full gap-1 rounded-2xl border border-[var(--line)] bg-[var(--surface-2)] p-1 md:w-auto md:self-start">
      {options.map((o) => {
        const on = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(o.value)}
            className={cx(
              'inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-xl px-3 text-[16px] font-semibold whitespace-nowrap transition md:flex-none md:px-5',
              on ? 'bg-[var(--surface)] text-[var(--accent)] shadow-[var(--shadow-card)]' : 'text-[var(--muted)] hover:text-[var(--ink)]',
            )}
          >
            {o.icon ? <o.icon className="hidden size-5 shrink-0 min-[420px]:block" aria-hidden /> : null}
            <span className="truncate">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
